import { trimEnd } from 'lodash-es';

/**
 * Retrieves the path to the SVG sprite file.
 *
 * The path only exists for the Electron and Adobe
 * environments and loaded from the local file system.
 * For the web environment, the path is empty and the sprite is
 * injected into the body to avoid CORS issues with <use href="..." />
 * as CORS is not supported for this particular attribute.
 */
const getSvgSpritePath = (): string => {
  if (window.PLATFORM === 'ELECTRON') {
    // Keep sprite loading same-origin in packaged app and dev server.
    return './static/images/icons.svg';
  }

  if (window.PLATFORM === 'ADOBE') {
    const trimmedPath = trimEnd(window.__dirname, '/');
    return `${trimmedPath}/static/images/icons.svg`;
  } else if (window.PLATFORM === 'RESOLVE') {
    let path = `.`;
    // TODO fix this hack, maybe after migrating Agent to Vite
    // biome-ignore lint/suspicious/noTsIgnore: meta.env fails in the agent TS, but this code path is for DaVinci Resolve only
    // @ts-ignore
    if (import.meta.env.MODE === 'development') {
      path = `./com.backlight.iconik/dist`;
    }

    return `${path}/static/images/icons.svg`;
  }

  return '';
};

export default getSvgSpritePath;
